export class SelfRegistrationRequestDto {
    constructor(public firstName: string,
                public lastName: string,
                public password: string,
                public locale: string,
                public email: string,
                public orgCode?: string) {
    }
}
